// account.js — öffentliche Seiten: Konto-Knopf für Angemeldete (Menü wird erst dann nachgeladen) und App-Version im Fuß.
// Ohne Anmeldung bleibt es bei „Anmelden“; kein Fehler, kein Nachladen.
const $ = (s) => document.querySelector(s);
const getJson = (u) => fetch(u, { credentials: 'same-origin', headers: { Accept: 'application/json' } }).then((r) => (r.ok ? r.json() : null)).catch(() => null);

const ver = $('[data-pub-version]');
if (ver) getJson('/api/public/version').then((d) => { if (d && d.version) ver.textContent = d.version; });

const slot = $('[data-pub-account]');
if (slot) getJson('/api/me/optional').then(async (me) => {
  if (!me || !me.id) return;
  const [{ mountAccount }, { url, HERE }] = await Promise.all([import('../ui/components/account-menu.js'), import('../shared/hosts.js')]);
  for (const a of document.querySelectorAll('[data-pub-login]')) a.hidden = true;
  mountAccount(slot, { me, current: HERE, profileUrl: url('app', '/profil') });
}).catch(() => {});
